import { IsString, IsOptional, IsDate, IsNumber } from "class-validator";
import { IContractAttachment } from "./contract-attachment.interface";

export class ContractAttachmentDto implements Omit<IContractAttachment, "_id"> {
  @IsString()
  contract_id: string;

  @IsString()
  file_name: string;

  @IsString()
  file_id: string; // AWS S3 reference

  @IsNumber()
  file_size: number; // file size in bytes
}
